import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {ColorWithVisibility} from '@mintdata/mint-kit/api/models/ColorWithVisibility';
import {BeanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/BeanConfig';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {ANumberConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ANumberConfig';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AStringConfig';
import {Font} from '@mintdata/mint-kit/api/models/Font';
import {FontConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/FontConfig';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {Units} from '@mintdata/mint-kit/api/models/Units';
import {UnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/UnitsConfig';
import {Color} from '@mintdata/mint-kit/api/models/Color';

export class LoaderCaption
{
    @Property<AString>({
        title: 'Text',
        tip: 'Text',
        isRequired: false,
        typeConfig: AStringConfig,
        typeCtor: AString
    })
    public text:AString;

    @Property<ABoolean>({
        title: 'Visible',
        tip: 'Visible',
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    public isVisible?:ABoolean;

    @Property<Font>({
        title: 'Font',
        tip: 'Font',
        isRequired: false,
        typeConfig: FontConfig,
        typeCtor: Font
    })
    public font:Font;

    public constructor(text:AString, isVisible:ABoolean, font:Font)
    {
        this.text = text;
        this.isVisible = isVisible;
        this.font = font;
    }

    public static default()
    {
        return new LoaderCaption(
            AString.fromString('Loading...'),
            ABoolean.false(),
            Font.default()
        );
    }
}

export class LoaderModel
{
    @Property<ABoolean>({
        title: 'Loading',
        tip: 'Loading',
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    public isLoading?:ABoolean;

    @Property<ABoolean>({
        title: 'Show Spinner',
        tip: 'Show Spinner',
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    public showSpinner?:ABoolean;

    @Property<Units>({
        title: 'Size',
        tip: 'Size',
        isRequired: true,
        typeConfig: UnitsConfig,
        typeCtor: Units
    })
    spinnerSize:Units;

    @Property<LoaderCaption>({
        title: 'Title',
        tip: `Title`,
        isRequired: true,
        typeConfig: BeanConfig,
        typeCtor: LoaderCaption
    })
    public caption:LoaderCaption;

    @Property<ColorWithVisibility>({
        title: 'Background Color',
        tip: 'Background Color',
        isRequired: true,
        typeConfig: BeanConfig,
        typeCtor: ColorWithVisibility
    })
    public bg:ColorWithVisibility;

    public constructor(isLoading?:ABoolean,
                       showSpinner?:ABoolean,
                       spinnerSize?:Units,
                       caption?:LoaderCaption,
                       bg?:ColorWithVisibility)
    {
        this.isLoading = isLoading;
        this.showSpinner = showSpinner;
        this.spinnerSize = spinnerSize;
        this.caption = caption;
        this.bg = bg;
    }

    public static default():LoaderModel
    {
        return new LoaderModel(
            ABoolean.false(),
            ABoolean.true(),
            Units.fromPixels(24),
            LoaderCaption.default(),
            new ColorWithVisibility(
                Color.fromRGBA(255, 255, 255, 0.75),
                ABoolean.true()
            )
        );
    }
}

